export interface MenuItem {
  label: string;
  route?: string;
  click?: () => void;
  show?: boolean;
  active?: boolean;
}

export interface HeaderConfig {
  showLogo: boolean;
  showMiddleSection: boolean;
  middleSectionText: string;
  showThemeToggle: boolean;
  showUnlockPremium: boolean;
  menuItems: MenuItem[];
  isHomePage?: boolean;
}

export interface BrandingConfig {
  logoUrl: string | null;
  bannerUrl: string | null;
}

export const DEFAULT_HEADER_CONFIG: HeaderConfig = {
  showLogo: true,
  showMiddleSection: false,
  middleSectionText: '',
  showThemeToggle: true,
  showUnlockPremium: false,
  menuItems: []
};
